import { useLocation } from 'react-router-dom';

const LOGO = (
  <img src="/assets/img/logo.svg" alt="G-Museum" className="logo-svg" />
);

export default function MobileMenu() {
  const location = useLocation();
  const isTickets = location.pathname === '/tickets';

  return (
    <header className="mobile-menu js-scroll-hide">
      <div className="mobile-menu-header">
        <div className="mobile-menu-logo">
          <a href="/" className="logotype" aria-label="G-Museum, inicio">
            {LOGO}
          </a>
        </div>
        <a
          href={isTickets ? '/' : '/tickets'}
          style={{
            padding: '8px 16px',
            background: '#000',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            whiteSpace: 'nowrap',
          }}
        >
          {isTickets ? 'На головну' : 'Купити квиток'}
        </a>
      </div>
    </header>
  );
}
